export interface Post {
  _id: string;
  _match_info?: MatchInfo;
  adult_content: boolean;
  author: string;
  bio: string;
  body: string;
  channels: string[];
  comments: number;
  country: string;
  description: string;
  emotions: string[];
  entities: string[];
  fetched: string;
  followers: number;
  following: number;
  gender: string;
  geohash: string;
  handle: string;
  influence: number;
  is_reply_or_share: string;
  language: string;
  likes: number;
  link: string;
  media_title: string;
  published: string;
  sentiment: string;
  shares: number;
  site: string;
  source: number;
  source_age: number;
  source_interests: string[];
  taxonomies: string[];
  themes: string[];
  title: string;
  total_engagements: number;
  views: number;
}

export interface MatchInfo {
  [key: string]: boolean | string | string[] | undefined;
}

export interface Label {
  [key: string]: Record<string, string>;
}

export interface PostListResponse {
  field_labels?: Record<string, string>;
  field_types?: Record<string, string>;
  records?: Post[];
  records_count?: number;
  value_labels?: Label;
  cursor?: string | null;
}

export interface PostListRequestBody {
  records: {
    size: number;
    cursor?: string | null;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export type PostListSettingsStateType = {
  pageSize: number;
  sortField: string;
  sortDirection: string;
}

export const postListDefaultSettings: PostListSettingsStateType = {
  pageSize: 25,
  sortField: "",
  sortDirection: "desc"
};

// `t` must come from the caller's useTranslation() - i18n isn't available at module load time here.
export const getPostListSortOptions = (t: (key: string) => string): Array<{ label: string, value: string }> => [
  { label: t("widget-types.post-list.post.engagements"), value: "total_engagements" },
  { label: t("widget-types.post-list.post.likes"), value: "likes" },
  { label: t("widget-types.post-list.post.comments"), value: "comments" },
  { label: t("widget-types.post-list.post.shares"), value: "shares" },
  { label: t("widget-types.post-list.post.views"), value: "views" },
  { label: t("widget-types.post-list.post.followers"), value: "followers" },
  { label: t("widget-types.post-list.post.influence"), value: "influence" },
  { label: t("widget-types.post-list.post.published"), value: "published" }
];